import './icon-animations.scss'

import React from 'react'

const CircleLoader = () => {
  return(
    <svg className="animation-spinner" viewBox='0 0 14 14' fill="none">
      <circle className="-primary-color" cx={7} cy={7} r={6} />
    </svg>
  )
}

export default CircleLoader